import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function AccessDenied() {
    return (
        <div className="w-full min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
                className="text-6xl mb-6 font-extrabold bg-gradient-to-b from-white to-white/40 bg-clip-text text-transparent"
            >
                Access denied
            </motion.div>

            <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                className="text-white/70 text-lg max-w-xl"
            >
                Nemáš oprávnění pro vstup na tuto stránku.
            </motion.p>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
                className="mt-10"
            >
                <Link
                    to="/"
                    className="px-6 py-3 bg-white text-black rounded-xl font-semibold text-sm hover:opacity-90"
                >
                    Zpět na hlavní stránku
                </Link>
            </motion.div>
        </div>
    );
}
